import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { Client } from '~weekly-planner/lib/common';

const ClientState = (state: RootState) => state.weeklyPlanner.clients;

export const selectAll = (state: RootState) => ClientState(state).rows;
export const selectSimulated = (state: RootState) => ClientState(state).simulated;

export const selectLoading = (state: RootState) => ClientState(state).loading;
export const selectHasLoaded = (state: RootState) => ClientState(state).hasLoaded;
export const selectParams = (state: RootState) => ClientState(state).params;

export const selectRenderable = createSelector(
  [selectAll, selectSimulated],
  (clients: Client[], simulated: Client[]) => {
    const simulatedMap = new Map(simulated.map((client) => [client.id, client]));

    return clients.map((client) => {
      const simulatedChange = simulatedMap.get(client.id);
      return simulatedChange || client;
    });
  },
);
